import { colors } from '@insurancemenu/imenu-components-lib';
import { createUseStyles } from 'react-jss';

const styles = {
  form: {
    color: colors.neutral[900],
  },
  subtitle: {
    marginBottom: '4rem',
  },
  formElements: {
    display: 'flex',
    flexDirection: 'column',
    gap: '3rem',
  },
  input: {
    width: '100%',
  },
  infoText: {
    fontSize: '1.3rem',
    lineHeight: '2rem',
    '& a': {
      margin: '0 0.5rem',
    },
  },
  button: {
    width: '100%',
    height: '4.4rem',
  },
  validButtonWrapper: {
    position: 'relative',
    padding: '5rem 0 1rem',
  },
  buttonWrapperWithError: {
    position: 'relative',
    padding: '1rem 0 1rem',
  },
  forgotLink: {
    textDecoration: 'none',
    height: '1.8rem',
  },
  forgotButton: {
    fontSize: '1.4rem',
  },
};

const createStyles = createUseStyles(styles);

export { styles, createStyles };
